'use strict';

import ReactDOM from 'react-dom';
import algoliasearch from 'algoliasearch/lite';
import { connectStateResults, Hits, InstantSearch, SearchBox } from 'react-instantsearch-dom';

const Result = ({ hit }) => {
	return (
		<div className="flex items-baseline mb-2 space-x-2 text-sm">
			<span className="text-gray-300">
				Jump to:
			</span>
			<a key={ hit.objectID } href={ `#${ hit.slug }` } className="font-semibold">
				{ hit.title }
			</a>
		</div>
	);
};

const Results = connectStateResults(({ searchState }) => {
	if (searchState && searchState.query) {
		return (
			<div className="p-4">
				<Hits hitComponent={ Result } />
			</div>
		);
	}
	
	return null;
});

const App = ({ client, index }) => {
	return (
		<div className="mt-6">
			<InstantSearch indexName={ index } searchClient={ client }>
				<SearchBox
					translations={ {
						submitTitle: 'Search Logos',
						resetTitle: 'Clear Search',
						placeholder: 'Search all logos by typing here...',
					} }
				/>
				<Results />
			</InstantSearch>
		</div>
	);
};

try {
	const element = document.querySelector('.logos-search');
	const client = algoliasearch(element.dataset.algoliaAppId, element.dataset.algoliaKey);
	const index = element.dataset.algoliaIndex;
	
	ReactDOM.render(<App client={ client } index={ index } />, element, () => {
		element.classList.remove('hidden');
	});
} catch (e) {
	console.error(e);
}
